import React, { useEffect, useState } from "react";
import { Link as DomLink } from "react-router-dom";
import api from "../../../utils/api";
import qs from "qs";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { constants } from "../../../utils";
import { Default, Mobile } from "../../../utils/deviceHelpers";

export default function StaticLanding(props) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [jobListings, setJobListings] = useState();
  const [copyBoxes1, setCopyBoxes1] = useState();
  const [copyBoxes2, setCopyBoxes2] = useState();
  const [greenrectangle, setGreenRectangle] = useState();

  const frontImageUrl = constants.CMS_FRONT_IMAGE_URL;

  const LeftCopyBox = (leftCopyBox) => (
    <Card sx={{ backgroundColor: "#e3e3e3", width: "100%" }}>
      <Stack direction="row" alignItems="center">
        <CardMedia
          sx={{ width: "50%" }}
          component="img"
          image={`${frontImageUrl}${leftCopyBox.image.data.attributes.url}`}
        />
        <CardContent sx={{ width: "50%" }}>
          <Stack spacing={3} sx={{ margin: "6rem" }}>
            <Typography variant="articleTitle" align="center">
              {leftCopyBox.title}
            </Typography>
            <Typography variant="staticText" align="center">
              <ReactMarkdown remarkGfm={[remarkGfm]}>
                {leftCopyBox.body}
              </ReactMarkdown>
            </Typography>
            {leftCopyBox.button && (
              <DomLink
                to={{ pathname: `${leftCopyBox.button.to}` }}
                className="center"
              >
                <Button variant="contained">{leftCopyBox.button.text}</Button>
              </DomLink>
            )}
          </Stack>
        </CardContent>
      </Stack>
    </Card>
  );

  const RightCopyBox = (rightCopyBox) => (
    <Card sx={{ backgroundColor: "#e3e3e3", width: "100%" }}>
      <Stack direction="row" alignItems="center">
        <CardContent sx={{ width: "50%" }}>
          <Stack spacing={3} sx={{ margin: "6rem" }}>
            <Typography variant="articleTitle" align="center">
              {rightCopyBox.title}
            </Typography>
            <Typography variant="staticText" align="center">
              <ReactMarkdown remarkGfm={[remarkGfm]}>
                {rightCopyBox.body}
              </ReactMarkdown>
            </Typography>
            {rightCopyBox.button && (
              <DomLink
                to={{ pathname: `${rightCopyBox.button.to}` }}
                className="center"
              >
                <Button variant="contained">{rightCopyBox.button.text}</Button>
              </DomLink>
            )}
          </Stack>
        </CardContent>
        <CardMedia
          sx={{ width: "50%" }}
          component="img"
          image={`${frontImageUrl}${rightCopyBox.image.data.attributes.url}`}
        />
      </Stack>
    </Card>
  );

  const MobileCopyBox = (mobileCopyBox) => (
    <Card sx={{ backgroundColor: "#e3e3e3", width: "100%" }}>
      <Stack alignItems="center">
        <CardMedia
          component="img"
          image={`${frontImageUrl}${mobileCopyBox.image.data.attributes.url}`}
        />
        <CardContent>
          <Stack spacing={3}>
            <Typography variant="articleTitle" align="center">
              {mobileCopyBox.title}
            </Typography>
            <Typography variant="staticText" align="center">
              <ReactMarkdown remarkGfm={[remarkGfm]}>
                {mobileCopyBox.body}
              </ReactMarkdown>
            </Typography>
            {mobileCopyBox.button && (
              <DomLink
                to={{ pathname: `${mobileCopyBox.button.to}` }}
                className="center"
              >
                <Button variant="contained">{mobileCopyBox.button.text}</Button>
              </DomLink>
            )}
          </Stack>
        </CardContent>
      </Stack>
    </Card>
  );

  useEffect(() => {
    const query = qs.stringify({
      populate: {
        joblistings: {
          populate: "*",
        },
        copyboxes1: {
          populate: "*",
        },
        greenrectangle: {
          populate: "*",
        },
        copyboxes2: {
          populate: "*",
        },
      },
    });
    api.fetchStrapi(`/careers-page?${query}`).then((response) => {
      setJobListings(response.data.data.attributes.joblistings);
      setCopyBoxes1(response.data.data.attributes.copyboxes1);
      setGreenRectangle(response.data.data.attributes.greenrectangle);
      setCopyBoxes2(response.data.data.attributes.copyboxes2);
      setIsLoaded(true);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {!isLoaded ? (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={true}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : (
        <Container maxWidth="xl" className="careers-text">
          <Mobile>
            <Stack spacing={3} alignItems="center">
              <Card sx={{ backgroundColor: "#e3e3e3", width: "100%" }}>
                <Stack alignItems="center">
                  <CardContent>
                    <Stack spacing={3} sx={{ marginBottom: "2rem" }}>
                      <Typography variant="articleTitle" align="center">
                        Open Positions
                      </Typography>
                      <Typography variant="staticText">
                        <ReactMarkdown remarkGfm={[remarkGfm]}>
                          {jobListings.jobpostings}
                        </ReactMarkdown>
                      </Typography>
                    </Stack>
                    <Stack spacing={3}>
                      <Typography variant="articleTitle" align="center">
                        {jobListings.title}
                      </Typography>
                      <Typography variant="staticText" align="center">
                        <ReactMarkdown remarkGfm={[remarkGfm]}>
                          {jobListings.body}
                        </ReactMarkdown>
                      </Typography>
                      <Typography variant="articleTitle" align="center">
                        {jobListings.redtext}
                      </Typography>
                    </Stack>
                  </CardContent>
                </Stack>
              </Card>
              {copyBoxes1.map((copyBox) => (
                <React.Fragment key={copyBox.id}>
                  {MobileCopyBox(copyBox)}
                </React.Fragment>
              ))}
              {greenrectangle && (
                <Typography variant="mobileGreenRectangle" align="center">
                  {greenrectangle.text}
                </Typography>
              )}
              {copyBoxes2.map((copyBox) => (
                <React.Fragment key={copyBox.id}>
                  {MobileCopyBox(copyBox)}
                </React.Fragment>
              ))}
            </Stack>
          </Mobile>
          <Default>
            <Stack spacing={3} alignItems="center">
              <Card sx={{ backgroundColor: "#e3e3e3", width: "100%" }}>
                <Stack direction="row" alignItems="center">
                  <CardContent sx={{ width: "50%" }}>
                    <Stack spacing={3} sx={{ margin: "6rem" }}>
                      <Typography variant="articleTitle" align="center">
                        {jobListings.title}
                      </Typography>
                      <Typography variant="staticText" align="center">
                        <ReactMarkdown remarkGfm={[remarkGfm]}>
                          {jobListings.body}
                        </ReactMarkdown>
                      </Typography>
                      <Typography variant="articleTitle" align="center">
                        {jobListings.redtext}
                      </Typography>
                    </Stack>
                  </CardContent>
                  <CardContent sx={{ width: "50%" }}>
                    <Stack spacing={3} sx={{ margin: "6rem" }}>
                      <Typography variant="articleTitle" align="center">
                        Open Positions
                      </Typography>
                      <Typography variant="staticText">
                        <ReactMarkdown remarkGfm={[remarkGfm]}>
                          {jobListings.jobpostings}
                        </ReactMarkdown>
                      </Typography>
                    </Stack>
                  </CardContent>
                </Stack>
              </Card>
              {copyBoxes1.map((copyBox) => (
                <React.Fragment key={copyBox.id}>
                  {copyBox.alignment === "left" ? (
                    <>{LeftCopyBox(copyBox)}</>
                  ) : (
                    <>{RightCopyBox(copyBox)}</>
                  )}
                </React.Fragment>
              ))}
              {greenrectangle && (
                <Typography
                  variant="greenRectangle"
                  align="center"
                  sx={{ width: "100%" }}
                >
                  {greenrectangle.text}
                </Typography>
              )}
              {copyBoxes2.map((copyBox) => (
                <React.Fragment key={copyBox.id}>
                  {copyBox.alignment === "left" ? (
                    <>{LeftCopyBox(copyBox)}</>
                  ) : (
                    <>{RightCopyBox(copyBox)}</>
                  )}
                </React.Fragment>
              ))}
            </Stack>
          </Default>
        </Container>
      )}
    </>
  );
}
